// extracted by mini-css-extract-plugin
export default {"header":"SettingsHeader_header__tJhvc","text":"SettingsHeader_text__zq9I+","buttonCont":"SettingsHeader_buttonCont__KBA88"};